module.exports = __webpack_public_path__ + "img/upload-id.ef120c51.png";